<template>
    <toolbar-option :message="message">
        <template slot="primary">
            <span class="option__multi-label">
                Important

                <tooltip>
                    Use ID of a component as a value for this field.
                </tooltip>
            </span>
            <input
                v-model="value"
                type="text"
                placeholder="Add ID value"
                @change="setChangedData(true)"
            >
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'aria-labelled-by',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'aria-labelledby',
            value: '',
            message: '* aria-labelledby overrides all other name sources for an element. So, for example, if an element has both an aria-labelledby and an aria-label, or an aria-labelledby and a native HTML label, the aria-labelledby label always takes precedence.',
        };
    },

    watch: {
        value() {
            this.selectedElements[0].ariaLabelledByNew = this.value;
            this.onOptionChange(this.value);
        },
    },

    methods: {
        onSelectedElement() {
            this.value = this.selectedElements[0].ariaLabelledByNew;
        },
    },
};
</script>
